<template>
  <div>
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" data-toggle="modal" data-target="#variaveis-modal">Variáveis</button>
    </div>
    <!-- TABELA DE E-MAILS -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">E-mails padrões</h3>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Assunto</th>
                <th>Destinatário</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(mail, index) in mail_templates" :key="mail">
                <td data-label="Tipo">{{ mail.tipo }}</td>
                <td data-label="Assunto">{{ mail.assunto }}</td>
                <td data-label="Destinatário">{{ mail.destinatario }}</td>
                <td>
                  <button type="submit" class="btn btn-primary" @click="selecionarMail(mail)" data-toggle="modal" data-target="#editar-modal">
                    Editar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + mail_templates.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- VARIÁVEIS -->
    <div class="modal fade" id="variaveis-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Variáveis disponíveis</h4>
              <br />

              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(variavel, index) in variaveis_disponiveis" :key="variavel">
                    <td>{{ variavel }}</td>
                    <td>
                      <button @click="copiarVariavel(variavel)" type="button" class="btn btn-default btn-sm">
                        <i class="fa-solid fa-copy"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button id="fechar_editar" style="margin-left: 15px" data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- EDITAR E-MAIL -->
    <div class="modal fade" id="editar-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar e-mail</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Tipo:</label>

                  <input readonly="true" class="form-control" v-model="mail_selecionado.tipo" id="conteudo_notificacao" />
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Assunto:</label>
                  <input class="form-control" v-model="formData.assunto" id="conteudo_notificacao" />

                  <span v-if="formData.destinatario == 'admin'" style="color: red" v-for="error in v$.assunto.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <div class="col-sm-12" v-if="mail_selecionado.destinatario == 'user'" >
              <b>Texto fixo nos e-mails: </b>
              <span>
              {{'Se destinatário for tipo user: "Prezado(a) Sr.(a). <NOME PF ou RAZÃO SOCIAL> (<APELIDO>)"'}}     
              </span>        
              </div>
              
              <div
                class="col-sm-12"
                v-if="
                  mail_selecionado.tipo == 'Exclusaolances'
                "
              >
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$justificativa>" }} ;</span>
                  <span>&nbsp;{{ "<$usuariologado>" }} ;</span>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="
                  mail_selecionado.tipo == 'Enviopropostavendaextrajudicial' ||
                  mail_selecionado.tipo == 'Enviopropostaparcelamentoleilao' ||
                  mail_selecionado.tipo == 'Enviopropostavendajudicial'
                "
              >
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$botao_lote>" }} ;</span>
                  <span>&nbsp;{{ "<$botao_leilao>" }} ;</span>
                  <span>&nbsp;{{ "<$num_leilao>" }} ;</span>
                  <span>&nbsp;{{ "<$botao_proposta>" }} ;</span>
                </div>
              </div>
              <div class="col-sm-12" v-else-if="mail_selecionado.tipo == 'Exclusaousuario'">
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$useridexcluido>" }} ;</span>
                  <span>&nbsp;{{ "<$apelidoexcluido>" }} ;</span>
                  <span>&nbsp;{{ "<$emailexcluido>" }} ;</span>
                </div>
              </div>
              <div class="col-sm-12" v-else-if="mail_selecionado.tipo == 'Bloquearhabilitacao' || mail_selecionado.tipo == 'Liberarhabilitacao'">
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$botao_leilao>" }} ;</span>
                  <span>&nbsp;{{ "<$botao_lote>" }} ;</span>
                  <span>&nbsp;{{ "<$num_leilao>" }} ;</span>
                </div>
              </div>
              <div class="col-sm-12" v-else-if="mail_selecionado.tipo == 'Solicitacaohabilitacao'">
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$botao_leilao>" }} ;</span>
                  <span>&nbsp;{{ "<$num_leilao>" }} ;</span>
                  <span>&nbsp;{{ "<$apelidosolicitante>" }} ;</span>
                  <span>&nbsp;{{ "<$nomesolicitante>" }} ;</span>
                  <span>&nbsp;{{ "<$tituloleilao>" }} ;</span>
                </div>
              </div>
              <div class="col-sm-12" v-else-if="mail_selecionado.tipo == 'Avisopublicacaoedital'">
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$datapublicacao>" }} ;</span>
                  <span>&nbsp;{{ "<$linkpublicacao>" }} ;</span>
                  <span>&nbsp;{{ "<$leilaorelacionado>" }} ;</span>
                </div>
              </div>
              <div class="col-sm-12" v-else-if="mail_selecionado.tipo == 'Compartilharwhatsapp'">
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                  <span>&nbsp;{{ "<$apelidosolicitante>" }} ;</span>
                  <span>&nbsp;{{ "<$num_leilao>" }} ;</span>
                  <span>&nbsp;{{ "<$num_lote>" }} ;</span>
                  <span>&nbsp;{{ "<$botao_leilao>" }} ;</span>
                </div>
              </div>
              <div class="col-sm-12" v-else>
                <div class="form-group">
                  <label for="leilao_info_geral">Variáveis disponíveis:</label>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo:</label>

                  <Editor
                    class="editor_prime"
                    style="background-color: white"
                    editorStyle="height: 200px;"
                    v-model="formData.corpo"
                    id="conteudo_notificacao"
                    @text-change="changeText"
                  />
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Rodapé:</label>

                  <Editor
                    class="editor_prime"
                    style="background-color: white"
                    editorStyle="height: 200px;"
                    v-model="formData.rodape"
                    id="conteudo_notificacao"
                  />
                </div>
              </div>

              <div class="col-sm-12">
                <input type="checkbox" v-model="formData.possui_texto_padrao" style="margin-bottom: 15px" />
                Exibir o campo 'Texto padrão' na tela de envio de e-mails
              </div>

              <div class="col-sm-12" v-if="exibir_texto_padrao">
                <div class="form-group">
                  <label>Textos padrão</label>

                  <div class="input-group">
                    <select class="custom-select rounded-0" v-model="texto_selecionado" @change="updateText(texto_selecionado.conteudo, false)">
                      <option v-for="texto in textos_padrao" :value="texto" :key="texto">{{ texto.titulo }}</option>
                    </select>
                    <div class="input-group-append">
                      <button
                        style="max-height: 40px"
                        type="submit"
                        class="btn btn-default"
                        data-toggle="modal"
                        data-target="#comitente-modal"
                        @click="criar_texto_padrao = true"
                      >
                        <i class="fas fa-plus"></i>
                        Novo texto
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <admin-cadastrar-texto-padrao v-if="criar_texto_padrao" :setCriarTexto="setCriarTexto" :textoCriado="textoCriado" />

              <div class="col-sm-12" v-if="mail_selecionado.destinatario == 'user'">
                <div class="form-group">
                  <label for="cco">Cco (valores separados por ;):</label>
                  <textarea
                    :disabled="mail_selecionado.tipo == 'Validaremail' || mail_selecionado.tipo == 'Validaremailcomnews'"
                    class="form-control"
                    name="cco"
                    rows="4"
                    cols="50"
                    style="width: 100%"
                    v-model="formData.cco"
                    @keyup="formatar"
                  ></textarea>
                </div>
              </div>

              <div class="col-sm-12" v-if="mail_selecionado.destinatario == 'admin'">
                <div class="form-group">
                  <label for="cco">To:</label>
                  <textarea class="form-control" name="cco" rows="4" cols="50" style="width: 100%" v-model="formData.to" @keyup="formatar"></textarea>

                  <span v-if="formData.destinatario == 'admin'" style="color: red" v-for="error in v$.to.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <button @click="update()" class="btn btn-primary btn-sm">
                Salvar
                <i class="fa fa-check"></i>
              </button>

              <button id="fechar_editar" style="margin-left: 15px" data-toggle="modal" data-target="#editar-modal" class="btn btn-danger btn-sm">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import useVueLidate from "@vuelidate/core";

export default {
  props: [""],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, Editor },

  data() {
    return {
      isLoading: false,
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      mail_selecionado: "",
      assunto: "",
      corpo: "",
      corpo_text: "",
      texto_teste: "",
      cco: "",
      to: "",
      mail_templates: "",
      data_teste: "Testando data",
      texto_selecionado: "",
      exibir_texto_padrao: false,
      criar_texto_padrao: false,
      textos_padrao: [],
      variaveis_disponiveis: [],
    };
  },

  setup() {
    const formData = reactive({
      assunto: "",
      corpo: "",
      corpo_text: "",
      cco: "",
      to: "",
      destinatario: "",
      novo_texto: "",
      possui_texto_padrao: "",
      rodape: "",
    });

    const rules = computed(() => {
      let local_rules = {};

      if (formData.destinatario == "admin") {
        local_rules.assunto = { required };
        local_rules.to = { required };
      }

      return local_rules;
    });

    const minDate = (date) => {
      return new Date(date) >= new Date();
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.variaveis_disponiveis.push("<$botao_lote>");
    this.variaveis_disponiveis.push("<$botao_leilao>");
    this.variaveis_disponiveis.push("<$num_leilao>");
    this.variaveis_disponiveis.push("<$botao_proposta>");
    this.variaveis_disponiveis.push("<$useridexcluido>");
    this.variaveis_disponiveis.push("<$apelidoexcluido>");
    this.variaveis_disponiveis.push("<$emailexcluido>");

    this.buscaremails();
    this.buscarTextosPadrao();

    this.total = this.mail_templates.length;
  },

  methods: {
    async copiarVariavel(variavel) {
      try {
        await navigator.clipboard.writeText(variavel);
        this.showSuccessMessage("Variável copiada!");
      } catch ($e) {
        alert("Cannot copy");
        console.log(e);
      }
    },

    textoCriado(data) {
      let btn = document.getElementById("fechar_texto_modal");

      btn.click();

      this.textos_padrao.push(data);

      this.setCriarTexto(false);
    },

    setCriarTexto(value) {
      let btn = document.getElementById("fechar_texto_modal");

      if (btn) {
        btn.click();
      }

      console.log("Setando " + value);

      this.criar_texto_padrao = false;
    },

    cadastrarComitente() {
      this.cadastrar_comitente = true;
    },

    updateText(html, isBefore) {
      html = " " + html + " ";

      var sel, range, node;
      if (window.getSelection) {
        sel = window.getSelection();

        console.log("\n\nSelection");
        console.log(sel);

        console.log("Focus node");
        console.log(sel.extentNode.nodeName);
        console.log(sel.focusNode.nodeName);
        console.log(sel.focusNode.localName);
        console.log(sel.focusNode);
        console.log(sel.anchorNode);

        if (sel.getRangeAt && sel.rangeCount) {
          range = window.getSelection().getRangeAt(0);
          range.collapse(isBefore);

          // Range.createContextualFragment() would be useful here but was
          // until recently non-standard and not supported in all browsers
          // (IE9, for one)

          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);

          this.texto_selecionado = null;

          /*
          const textNode = document.createTextNode('"Text"');
          range.insertNode(textNode);
          */
        }
      } else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();
        range.collapse(isBefore);
        range.pasteHTML(html);
      }
    },

    buscarTextosPadrao() {
      let data = {
        inicio: this.inicio,
        tamanho: 10000,
      };

      axios
        .post(`/admin/texto_padrao/search`, data)
        .then((response) => {
          this.textos_padrao = response.data.textos_padrao;

          this.pagination(response.data);

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscaremails() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Atualizando");
      console.log(data);

      axios
        .post(`/admin/mail_template/search`, data)
        .then((response) => {
          this.mail_templates = response.data.mails;
          this.total = response.data.total;

          this.pagination(response.data);

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    changeText(textValue) {
      this.formData.corpo_text = textValue.textValue;
    },

    selecionarMail(mail) {
      //this.mail_selecionado = mail;
      //this.assunto = mail.assunto;
      //this.corpo = mail.corpo;
      //this.corpo_text = null;
      //this.cco = mail.cco;
      //this.to = mail.to;

      this.mail_selecionado = mail;
      this.formData.assunto = mail.assunto;
      this.formData.corpo = mail.corpo;
      this.formData.corpo_text = null;
      this.formData.cco = mail.cco;
      this.formData.to = mail.to;
      this.formData.destinatario = mail.destinatario;
      this.formData.possui_texto_padrao = mail.possui_texto_padrao == 1;
      this.formData.rodape = mail.rodape;
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    getUrlEdit(logo) {
      return "/admin/logo/" + logo.id;
    },

    show(logo) {
      this.logo_selecionado = logo;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscaremails();
      }
    },

    formatar() {
      if (this.formData.cco) {
        this.formData.cco = this.replaceAll(this.formData.cco.trim(), " ", "");
      }

      if (this.formData.to) {
        this.formData.to = this.replaceAll(this.formData.to.trim(), " ", "");
      }
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    async update() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          id: this.mail_selecionado.id,
          assunto: this.formData.assunto,
          corpo: this.formData.corpo,
          corpo_text: this.formData.corpo_text,
          cco: this.formData.cco,
          to: this.formData.to,
          possui_texto_padrao: this.formData.possui_texto_padrao ? 1 : 0,
          rodape: this.formData.rodape,
        };

        console.log("Atualizando");
        console.log(data);

        axios
          .post(`/admin/mail_templates/update`, data)
          .then((response) => {
            let btn = document.getElementById("fechar_editar");

            btn.click();

            this.isLoading = false;

            this.showSuccessMessage("Dados atualizados");

            this.buscaremails();
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      } else {
        console.log(this.v$);
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscaremails();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
